





















import { defineComponent } from '@vue/composition-api';
import CardSelect from '@/components/common/card-select/index.vue';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';

const name = 'ttam-promotion-flow-type';
export default defineComponent({
  name,
  components: { CardSelect, QuestionTooltip },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onInput = (val: number) => {
      emit('input', val);
    };
    const onChange = (val: Record<string, unknown>) => {
      emit('change-item', val);
    };

    return {
      name,
      onInput,
      onChange,
    };
  },
});
